const tableFields = [
    {
        key: 'no',
        label: 'NUMBER',
        thClass: 'grid__width-88',
        tdClass: 'grid__width-88'
    },
    {
        key: 'crfNo',
        label: 'CRF NUMBER',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'jobDesc',
        label: 'DESKRIPSI PEKERJAAN',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'jobsiteUser',
        label: 'JOBSITE PENGGUNA',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'crfTotalCostEstimation',
        label: 'ESTIMASI BIAYA',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'crfCurrency',
        label: 'CURRENCY CRF',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'coupaTotalAmount',
        label: 'BIAYA FINAL',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'coupaCurrency',
        label: 'CURRENCY FINAL',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'vendorName',
        label: 'VENDOR NAME',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'expenditure',
        label: 'EXPENDITURE',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'jobNeed',
        label: 'KEBUTUHAN PEKERJAAN',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'picUser',
        label: 'PIC USER',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'picBudget',
        label: 'PIC BUDGET',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'picProcurement',
        label: 'PIC PROCUREMENT',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'crfCreatedUtcDate',
        label: 'CRF CREATED DATE',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'crfStatus',
        label: 'CRF STATUS',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'picPendingApproval',
        label: 'PIC PENDING APPROVAL CRF',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'rolePendingApproval',
        label: 'ROLE',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'coupaPrId',
        label: 'COUPA PR ID',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'piccms',
        label: 'PIC CMS',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'contractNumber',
        label: 'CONTRACT NUMBER',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'contractStatus',
        label: 'CONTRACT STATUS',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'contractExpiredUtcDate',
        label: 'EXPIRY DATE CONTRACT',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'crfSubmittedUtcDate',
        label: 'CRF SUBMIT',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'managerFuncReceivedUtcDate',
        label: 'CRF DITERIMA MANAGER FUNC.',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'managerFuncApprovedUtcDate',
        label: 'CRF Approved/Rejected Manger Func.',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'managerFuncReviseUtcDate',
        label: 'CRF REVISE MANAGER FUNC.',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'managerFuncResubmitUtcDate',
        label: 'CRF RESUBMIT TO MANAGER FUNC.',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'gmFuncApprovedUtcDate',
        label: 'CRF APPROVED/REJECTED GM FUNC.',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'directorFuncApprovedUtcDate',
        label: 'CRF APPROVED/REJECTED DIRECTOR FUNC.',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'leadtimeManagerFunc',
        label: 'LEAD TIME MANAGER FUNC.',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'leadtimeGMFunc',
        label: 'LEADTIME GM FUNC.',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'leadtimeDirectorFunc',
        label: 'LEADTIME DIRECTOR FUNC.',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'bucReceivedUtcDate',
        label: 'CRF DITERIMA PIC BUC',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'bucApprovedUtcDate',
        label: 'CRF APPROVED/REJECTED BUC',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'bucReviseUtcDate',
        label: 'CRF REVISE BUC',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'bucResubmitUtcDate',
        label: 'CRF RESUBMIT TO BUC',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'bucManagerApprovedUtcDate',
        label: 'CRF APPROVED/REJECTED BUC MANAGER',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'leadtimeBUC',
        label: 'LEADTIME BUC',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'picProcurementReceivedUtcDate',
        label: 'CRF DITERIMA PROCUREMENT',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'picProcurementApprovedUtcDate',
        label: 'CRF APPROVED/REJECTED PROCUREMENT',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'picProcurementReviseUtcDate',
        label: 'CRF REVISE PROCUREMENT',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'picProcurementResubmitUtcDate',
        label: 'CRF RESUBMIT TO PROCUREMENT',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'sourcingRequestCreatedUtcDate',
        label: 'PROCUREMENT SOURCING REQUEST',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'leadtimePICProcurement',
        label: 'LEADTIME PROCUREMENT',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'cifSubmittedUtcDate',
        label: 'CIF SUBMITTED',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'cifApprovedUtcDate',
        label: 'CIF APPROVED',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'contractCreatedUtcDate',
        label: 'CONTRACT CREATED',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'contractReceivedEndUserUtcDate',
        label: 'CONTRACT DITERIMA END USER',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'contractApprovedEndUserUtcDate',
        label: 'CONTRACT APPROVED END USER',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'contractApprovedBuyerUtcDate',
        label: 'CONTRACT APPROVED BUYER',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'contractPublishedUtcDate',
        label: 'CONTRACT PUBLISHED',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'leadtimeLegal',
        label: 'LEADTIME LEGAL',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'leadtimeContractApproval',
        label: 'LEADTIME CONTRACT APPROVAL',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    },
    {
        key: 'leadtimeContractProcess',
        label: 'LEADTIME CONTRACT PROCESS',
        thClass: 'grid__width-227',
        tdClass: 'grid__width-227'
    }
];
var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getPscmReportingList";
    Actions["GET_DOWNLOAD_EXCEL"] = "getDownloadExcelPscmReporting";
    Actions["GET_LOOKUP_OPTIONS"] = "getPscmReportingLookupFilter";
    Actions["GET_CHART"] = "getPscmChartReporting";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_LIST"] = "setPscmReportingList";
    Mutations["SET_LOOKUP_FILTER"] = "setPscmReportingLookupFilter";
    Mutations["SET_RESET_FORM_FILTER"] = "setPscmReportingFormFilterReset";
    Mutations["SET_RESET_ALL_FILTER"] = "setPscmReportingResetAllFilter";
    Mutations["SET_FILTER_TIPS"] = "setFilterTipsPscmReporting";
    Mutations["SET_DELETE_FILTER_TIPS"] = "setDeleteFilterTipsPscmReporting";
    Mutations["SET_NOT_FOUND"] = "setListNotFoundPSCMReporting";
    Mutations["SET_IS_CREATED_DATE_CHANGE"] = "setIsCreatedDateChange";
    Mutations["SET_CHART"] = "setPscmChartReporting";
    Mutations["SET_MANUAL_FORM_FILTER"] = "setPscmReportingFormFilterManual";
})(Mutations || (Mutations = {}));
export { Actions, Mutations, tableFields };
